"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolveAlarmMutation = exports.useAcknowledgeAlarmMutation = exports.useGetActiveAlarmCountQuery = exports.useGetAlarmsQuery = exports.useGetAlarmQuery = exports.alarmApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.alarmApi = (0, react_1.createApi)({
    reducerPath: "alarmApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["alarm"],
    endpoints: function (builder) { return ({
        getAlarm: builder.query({
            query: function (id) { return "/v1/alarm/".concat(id); },
            providesTags: ["alarm"],
        }),
        getAlarms: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/alarm", function (arg) { return ({
                facility_id: arg.facilityId,
                area_id: arg.areaId,
                status: arg.statuses,
            }); }),
            providesTags: ["alarm"],
        }),
        // Counted server-side; the side-nav badge polls it. The user id keys the cache per signed-in user.
        getActiveAlarmCount: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/alarm/active-count"),
            providesTags: ["alarm"],
        }),
        acknowledgeAlarm: builder.mutation({
            query: function (id) { return ({ url: "/v1/alarm/".concat(id, "/acknowledge"), method: "PATCH" }); },
            invalidatesTags: ["alarm"],
        }),
        resolveAlarm: builder.mutation({
            query: function (id) { return ({ url: "/v1/alarm/".concat(id, "/resolve"), method: "PATCH" }); },
            invalidatesTags: ["alarm"],
        }),
    }); },
});
exports.useGetAlarmQuery = exports.alarmApi.useGetAlarmQuery, exports.useGetAlarmsQuery = exports.alarmApi.useGetAlarmsQuery, exports.useGetActiveAlarmCountQuery = exports.alarmApi.useGetActiveAlarmCountQuery, exports.useAcknowledgeAlarmMutation = exports.alarmApi.useAcknowledgeAlarmMutation, exports.useResolveAlarmMutation = exports.alarmApi.useResolveAlarmMutation;
